import { useState } from 'react';
import { Icons } from '../../../icons';
import { showSuccessMessage } from 'helpers';
import { EmailForm } from '../EmailForm';
import styles from './styles.module.scss';
import classNames from 'classnames';

type EmailPropsType = {
  rowClassName: string;
  labelClassName: string;
  iconClassName: string;
  emailClassName: string;
  isAgent: boolean;
  contact;
};

const Email = (props: EmailPropsType) => {
  const { rowClassName, labelClassName, iconClassName, isAgent, contact, emailClassName } = props;
  const [editEmail, setEditEmail] = useState(false);
  const [open, setOpen] = useState(false);

  const handleEmailCopy = () => {
    navigator.clipboard.writeText(contact.Email);
    showSuccessMessage('Email copied.');
  };

  const handleEmailClose = () => {
    setEditEmail(false);
  };

  return (
    <>
      <div
        className={classNames(rowClassName, styles.container)}
        onMouseEnter={() => {
          if (!isAgent && !editEmail) setOpen(true);
        }}
        onMouseLeave={() => setOpen(false)}
      >
        {open && !isAgent ? (
          <div className={styles.menu}>
            <div
              className={classNames(styles.item, styles.itemOne)}
              onClick={() => {
                setOpen(false);
                setEditEmail(true);
              }}
            >
              <Icons variant={Icons.EDIT} color={'#747475'} />
              Edit
            </div>
            <div className={styles.separator}></div>
            <div
              className={classNames(styles.item, styles.itemTwo)}
              onClick={() => {
                setOpen(false);
                handleEmailCopy();
              }}
            >
              <Icons variant={Icons.COPY} color={'#747475'} />
              Copy
            </div>
          </div>
        ) : null}
        <p className={labelClassName}>
          Email
          {isAgent && (
            <span className={iconClassName} onClick={handleEmailCopy}>
              <Icons variant={Icons.COPY} />
            </span>
          )}
        </p>
        <p className={emailClassName}>{contact.Email}</p>
      </div>
      {editEmail && (
        <EmailForm
          clientId={contact.Id}
          value={{ email: contact.Email }}
          handleClose={handleEmailClose}
        />
      )}
    </>
  );
};

export default Email;
